module.exports = __webpack_public_path__ + "static/media/Architecture_21.97877142.jpg";